import { Globe } from "lucide-react";

export function WebsitePublisherCard({ webStatus }) {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
      <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between">
        <h2 className="font-display font-bold text-[#0f172a] text-sm flex items-center gap-2">
          <span className="w-8 h-8 rounded-lg bg-indigo-50 flex items-center justify-center"><Globe size={15} className="text-indigo-500" /></span>
          Website blog publisher
        </h2>
        {webStatus && (
          <span data-testid="website-status-badge" className={`text-[10px] tracking-[0.15em] font-semibold px-3 py-1 rounded-full border uppercase ${
            webStatus.configured ? "bg-emerald-50 text-emerald-600 border-emerald-200" : "bg-rose-50 text-rose-500 border-rose-200"}`}>
            {webStatus.configured ? "Configured" : "Not configured"}
          </span>
        )}
      </div>
      <div className="p-6 space-y-4">
        <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 text-xs space-y-1.5">
          <p className="text-slate-500">Target: <span className="text-[#0f172a] font-semibold mono">{webStatus?.base_url || "…"}</span></p>
          <p className="text-slate-500">API key: <span className="text-[#0f172a] font-semibold mono">{webStatus?.key_masked || "not set"}</span> <span className="text-slate-400">(stored server-side only, never logged)</span></p>
          {webStatus?.blog_url && (
            <p className="text-slate-500">Public blog: <a href={webStatus.blog_url} target="_blank" rel="noopener noreferrer" className="text-indigo-600 font-semibold hover:underline">{webStatus.blog_url}</a></p>
          )}
        </div>
        <p className="text-xs text-slate-500 leading-relaxed">
          From any draft, hit <span className="text-[#0f172a] font-semibold">Generate blog version</span> to expand the post into a full markdown article, then choose <span className="text-[#0f172a] font-semibold">LinkedIn, Website blog, or both</span> in the publish gate. Articles go live on your site instantly — no rebuild.
        </p>
      </div>
    </div>
  );
}

export function ManualPostingCard() {
  return (
    <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-6">
      <h2 className="font-display font-bold text-[#0f172a] text-sm mb-2">LinkedIn auto-publish is live</h2>
      <p className="text-xs text-slate-500 leading-relaxed">
        LinkedIn's Community Management API is now approved. Connect your account above, set your Organization ID, and hitting <span className="text-[#0f172a] font-semibold">Publish</span> in the composer posts directly to your Company Page. Every draft still has a <span className="text-[#0f172a] font-semibold">Copy</span> button as a manual fallback if you ever need it.
      </p>
    </div>
  );
}
